import OBase from './OBase';

import * as Geometry from '../geometry';

export default class ConstructPath extends OBase {
  update () {
    let valTree = this.getFloatInput('Indices');
    let pOutput = this.getGenericObjectOutput('Branch');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      let outpath = '{';

      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = Math.round(valTree.branches[i][j]);
        outpath += val.toString();
        if (j < valTree.branches[i].length - 1) {
          outpath += ';';
        }
      }
      outpath += '}';

      outTree.add(outpath, valTree.paths[i]);
    }

    pOutput.value = outTree;
    console.log(outTree);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ConstructPath.js